"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldBannerCoreInputs = void 0;
const banner_variant_1 = require("./banner.variant");
class EmeraldBannerCoreInputs {
    constructor() {
        this.open = false;
        this.content = '';
        this.hasAction = false;
        this.actionText = '';
        this.autoDismiss = false;
        this.autoDismissMilliseconds = 5000;
        this.variant = banner_variant_1.EmeraldBannerVariant.INFO;
    }
}
exports.EmeraldBannerCoreInputs = EmeraldBannerCoreInputs;
//# sourceMappingURL=banner.inputs.js.map